
import { defineComponent } from 'vue';
import {
  ActivityIndicator,
  AjaxHelper,
  MatomoUrl,
} from 'CoreHome';
import Multiselect from 'vue-multiselect';
import CreateGroup from './CreateGroup.vue';
import ManageGroup from './ManageGroup.vue';

export interface Group {
  idGroup: number;
  name: string;
}

export default defineComponent({
  components: {
    ActivityIndicator,
    Multiselect,
    CreateGroup,
    ManageGroup,
  },
  data() {
    return {
      groups: [] as Group[],
      selectedGroup: undefined as Group | undefined,
      isLoadingGroups: false,
      isLoadingDefaultGroup: false,
    };
  },
  mounted() {
    this.loadGroupList();
    this.loadDefaultGroup();
  },
  methods: {
    loadGroupList() {
      this.isLoadingGroups = true;

      AjaxHelper.post({
        module: 'API',
        format: 'json',
        method: 'GroupPermissions.getAllGroups',
      }, {
      },
      {
        errorElement: '#ajaxErrorManageGroups',
      }).then((response) => {
        this.groups = response;
      }).finally(() => {
        this.isLoadingGroups = false;
      });
    },
    loadDefaultGroup() {
      this.isLoadingDefaultGroup = true;

      const idGroup = MatomoUrl.getSearchParam('idGroup');
      if (idGroup) {
        AjaxHelper.post({
          module: 'API',
          format: 'json',
          method: 'GroupPermissions.getGroupWithId',
        }, {
          idGroup,
        },
        {
          errorElement: '#ajaxErrorManageGroups',
        }).then((response) => {
          this.selectedGroup = {
            idGroup: response.idGroup,
            name: response.name,
          };
        }).finally(() => {
          this.isLoadingDefaultGroup = false;
        });
      }
    },
    onGroupCreated(group: Group) {
      this.groups.push(group);
      this.sortGroups();
      this.selectedGroup = group;
    },
    onGroupRenamed(group: Group) {
      const groupIndex = this.groups.findIndex(
        (g: Group) => g.idGroup === group.idGroup,
      );
      this.groups[groupIndex].name = group.name;
      this.sortGroups();
      this.selectedGroup = group;
    },
    onGroupDeleted(group: Group) {
      this.groups = this.groups.filter((g: Group) => g.idGroup !== group.idGroup);
      this.selectedGroup = this.groups.length > 0 ? this.groups[0] : undefined;
    },
    sortGroups() {
      this.groups.sort((a: Group, b: Group) => a.name.localeCompare(b.name));
    },
  },
});
